module.exports = __webpack_public_path__ + "static/media/Week3.e296a0e7.pdf";